import styled from 'styled-components'
import { Modal } from 'semantic-ui-react'

export const PolicyHint = styled.div`
    padding: 10px 12px;
    background: #f9fafb;
    border-left: 3px solid #9ca3af;
    border-radius: 4px;
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
    line-height: 1.5;
`

export const PolicyFieldBox = styled.div`
    background: #eff6ff;
    padding: 14px;
    border-radius: 8px;
    border: 1px dashed #2563eb;
    margin-bottom: 8px;

    label {
        font-weight: 600;
    }

    .helper {
        display: block;
        font-size: 12px;
        color: #6b7280;
        font-weight: 400;
        margin: 4px 0 8px;
        line-height: 1.45;
    }
`

export const Segmented = styled.div`
    display: inline-flex;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
`

export const SegBtn = styled.button`
    border: none;
    background: ${p => (p.$on ? '#2563eb' : '#fff')};
    color: ${p => (p.$on ? '#fff' : '#374151')};
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    font-family: inherit;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`

export const InlineRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
`

export const ReminderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    min-height: 36px;

    .minutes-label {
        color: #6b7280;
        font-size: 13px;
        line-height: 1;
        white-space: nowrap;
    }

    .ui.input,
    .ui.input input {
        margin: 0 !important;
        vertical-align: middle;
    }
`

export const FormHelper = styled.span`
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: #6b7280;
    font-weight: 400;
    line-height: 1.45;
`

export const ModalError = styled.div`
    color: #b91c1c;
    font-size: 13px;
    margin-bottom: 12px;
`

export const TypeChip = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-left: 6px;
    background: ${p => {
        if (p.$kind === 'team') return '#ede9fe'
        if (p.$kind === 'vendor') return '#e5e7eb'
        return '#f3f4f6'
    }};
    color: ${p => {
        if (p.$kind === 'team') return '#6d28d9'
        if (p.$kind === 'vendor') return '#6b7280'
        return '#374151'
    }};
`

export const ActiveChip = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    background: ${p => (p.$active ? '#d1fae5' : '#e5e7eb')};
    color: ${p => (p.$active ? '#065f46' : '#6b7280')};
`

export const LinkBtn = styled.button`
    background: none;
    border: none;
    padding: 0;
    color: #2563eb;
    cursor: pointer;
    font: inherit;
    font-weight: 500;

    &:hover {
        text-decoration: underline;
    }

    &:disabled {
        color: #9ca3af;
        cursor: not-allowed;
    }
`

export const PolicyModalActions = styled(Modal.Actions)`
    &&& {
        display: flex !important;
        justify-content: ${p => p.$end ? 'flex-end' : 'space-between'};
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        background: #f9fafb !important;
        padding: 14px 16px 20px !important;
    }
`
